/** Joins the truthy class names: `cx(styles.card, isOpen && styles.open)` → "card open". */
export const cx = (...names: Array<string | false | null | undefined>) => names.filter(Boolean).join(' ');
